import { request } from "@/utils/request"

export function createOrder(data) {
    return request({
        url: "api/facebook-ads/create",
        method: "post",
        data
    })
}
export function getListOrder(param = null) {
    return request({
        url: "api/facebook-ads" + (param ? param : ""),
        method: "get"
    })
}
export function removeOrder(data) {
    return request({
        url: "api/facebook-ads/remove",
        method: "post",
        data
    })
}

export function createOrderSv3(data) {
    return request({
        url: "api/facebook-ads/vip-like/buy",
        method: "post",
        data
    })
}

export function getListOrderSv3(param = null) {
    return request({
        url: "api/facebook-ads/vip-like" + (param ? param : ""),
        method: "get"
    })
}
